import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from "react-router-dom";
import { useTrackingCode } from "react-hubspot-tracking-code-hook";
import { FormPage } from "./contents/form-page";


export const Error404: React.FC = () => {
  const { setPathPageView } = useTrackingCode();
  setPathPageView("/error-404");

  const navigate = useNavigate();

  return (
    <FormPage displayFooter={true}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={<Button type="primary" onClick={() => navigate('/')}>Back Home</Button>}
      />
    </FormPage>
  );
};
